import React from "react";
import { Link } from "react-router-dom";

interface BlogCardProps {
  blog: {
    pk: string;
    sk: string;
    title: string;
    metaDescription: string;
    introParagraph?: string;
    middleParagraph?: string;
    conclusionParagraph?: string;
    subject?: string;
    city?: string;
    state?: string;
  };
}

const BlogCard: React.FC<BlogCardProps> = ({ blog }) => {
  const getBlogExcerpt = () => {
    return (
      blog.metaDescription ||
      blog.introParagraph?.substring(0, 150) + "..." ||
      "Read this comprehensive cannabis guide..."
    );
  };

  const parseSubjectCityState = () => {
    if (blog.subject && blog.city && blog.state) {
      return { subject: blog.subject, city: blog.city, state: blog.state };
    }

    // Parse from sk if not directly available
    const [subjectPart, cityStatePart] = blog.sk.split("/", 2);
    const [cityPart, statePart] = cityStatePart?.split("-", 2) || ["", ""];

    return {
      subject:
        blog.subject ||
        subjectPart
          ?.replace(/-/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase()) ||
        "Cannabis",
      city:
        blog.city ||
        cityPart?.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) ||
        "Washington",
      state: blog.state || (statePart || "DC").toUpperCase(),
    };
  };

  const { subject, city, state } = parseSubjectCityState();

  return (
    <article className="solid-blog-card-navy backdrop-blur-sm rounded-xl overflow-hidden transition-all duration-500 hover:scale-[1.03] group hover:shadow-2xl hover:shadow-justice-gold-500/20 shadow-lg border border-justice-gold-500/30 relative">
      {/* Blog Content */}
      <div className="p-6">
        <h2 className="text-xl font-bold text-yellow-300 mb-3 line-clamp-2">
          <Link
            to={`/${blog.sk}`}
            className="hover:text-yellow-200 transition-colors"
          >
            {blog.title}
          </Link>
        </h2>

        <p className="text-gray-200 text-sm mb-4 line-clamp-3 leading-relaxed">
          {getBlogExcerpt()}
        </p>

        {/* Blog Tags */}
        <div className="flex flex-wrap gap-2 mb-4">
          <span className="px-3 py-1 bg-cannabis-green-900 text-cannabis-green-200 text-xs rounded-full font-medium">
            {subject}
          </span>
          <span className="px-3 py-1 bg-legal-blue-900 text-malibu-blue-200 text-xs rounded-full font-medium">
            {city}
          </span>
          <span className="px-3 py-1 bg-justice-gold-900 text-justice-gold-200 text-xs rounded-full font-medium">
            {state}
          </span>
        </div>

        <Link
          to={`/blog/${blog.sk}`}
          className="inline-flex items-center gap-2 text-cannabis-green-300 hover:text-cannabis-green-200 transition-colors font-semibold text-sm bg-cannabis-green-900/40 px-3 py-1.5 rounded-lg"
        >
          Read More
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
